/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type GroupByConversationTopicKind =
  (typeof GroupByConversationTopicKind)[keyof typeof GroupByConversationTopicKind];

export const GroupByConversationTopicKind = {
  conversation_topic: 'conversation_topic',
} as const;
